var ScoreCalculator = /** @class */ (function () {
    function ScoreCalculator() {
    }
    ScoreCalculator.prototype.totalScore = function (questions) {
        var _this = this;
        return questions
            .reduce(function (totalScore, question) { return totalScore + _this.questionScore(question); }, 0);
    };
    ScoreCalculator.prototype.scorePercentage = function (questions) {
        var minScore = this.minimumScore(questions);
        var maxScore = this.maximumScore(questions) - minScore;
        if (maxScore === 0 && minScore === 0) {
            return 1;
        }
        var totalScore = this.totalScore(questions) - minScore;
        if (totalScore < 0) {
            return 0;
        }
        return totalScore / maxScore;
    };
    ScoreCalculator.prototype.maximumScore = function (questions) {
        var _this = this;
        return questions
            .reduce(function (totalScore, question) { return totalScore + _this.questionMaxScore(question); }, 0);
    };
    ScoreCalculator.prototype.minimumScore = function (questions) {
        var _this = this;
        var minscore = questions
            .reduce(function (totalScore, question) { return totalScore + _this.questionMinScore(question); }, 0);
        return (minscore >= 0) ? minscore : 0;
    };
    ScoreCalculator.prototype.questionScore = function (question) {
        if (!question.answer) {
            return 0;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return question.answer.reduce(function (scores, answer) { return (answer.score ? scores + parseInt(answer.score) : scores); }, 0);
    };
    ScoreCalculator.prototype.questionMaxScore = function (question) {
        if (question.score && !question.options) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (question.score > 0 ? parseInt(question.score) : 0);
        }
        // Sum of all the options when multiselect question
        if (question.type === 'select' && question.subtype === 'multiple') {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return question.options.reduce(function (scores, option) { return scores + (option.score > 0 ? parseInt(option.score) : 0); }, 0);
        }
        // Return max when only one of the options is allowed
        if (['select', 'polar'].includes(question.type)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Math.max.apply(Math, question.options.map(function (q) { return (q.score > 0 ? parseInt(q.score) : 0); }));
        }
        return 0;
    };
    ScoreCalculator.prototype.questionMinScore = function (question) {
        if (question.score && !question.options) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (question.score < 0 ? parseInt(question.score) : 0);
        }
        // Sum of all the options when multiselect question
        if (question.type === 'select' && question.subtype === 'multiple') {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return question.options.reduce(function (scores, option) { return scores + (option.score < 0 ? parseInt(option.score) : 0); }, 0);
        }
        // Return min when only one of the options is allowed
        if (['select', 'polar'].includes(question.type)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Math.min.apply(Math, question.options.map(function (q) { return (q.score < 0 ? parseInt(q.score) : 0); }));
        }
        return 0;
    };
    return ScoreCalculator;
}());
export default ScoreCalculator;
